<template>
	<div class="application">
		<div class="application-wrap">
			<div class="header">
				<h1 class="animate">{{ $t('aurora.title') }}</h1>
			</div>
			<div class="application-inner">
				<div class="custom mb-54">
					<div class="header fd-cl">
						<div class="logo">
							<LazyImage :imagePath="mcStoreLogo" ></LazyImage>
						</div>
						<div class="intro">
							<p class="animate">{{ $t('aurora.mcstore') }}</p>
						</div>
					</div>
					<div class="bg">
						<img src="../../static/img/icon-bg-img.png" alt="">
					</div>
					<div class="app-img">
						<LazyImage :imagePath="mcStoreMain" ></LazyImage>
					</div>
				</div>
			<div class="custom mb-54" v-if="locale == 'ru_RU'">
				<div class="header fd-cl">
					<div class="logo">
						<LazyImage :imagePath="mcPlayerLogo" ></LazyImage>
					</div>
					<div class="intro">
						<p class="animate">{{ $t('aurora.mcplayer') }}</p>
					</div>
				</div>
				<div class="bg">
					<img src="../../static/img/icon-bg-img.png" alt="">
				</div>
				<div class="app-img">
					<LazyImage :imagePath="mcPlayerMain" ></LazyImage>
				</div>
			</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TvApplcation',
		components: {},
		data() {
			return {
				mcStoreLogo: require('@/static/img/mcstore-logo-img.png'),
				mcStoreMain: require('@/static/img/mcpstore-main-img.png'),
				mcPlayerMain: require('@/static/img/mcplayer-main-img.png'),
				mcPlayerLogo: require('@/static/img/mcplayer-logo-img.png')
			};
		},
		computed: {
			locale () {
				return this.$i18n.locale || 'ru_RU'
			}
		},
		methods: {

		},
		created() {

		},
		mounted() {
		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	.application {
		padding: 54px 24px 0;
	}

	.application-wrap {
		max-width: 1280px;
		margin: 0 auto;

		.header {
			padding-top: 38px;
			h1 {
				text-align: center;
				color: #fff;
			}
		}
	}

	.application-inner {
		position: relative;

		.bg {}
	}

	.custom {
		position: relative;

		.header {
			display: flex;
			align-items: center;
			gap: 33px;
			color: #fff;
		}

		.bg {
			img {
				width: 100%;
				height: 100%;
			}
		}
		.logo{
			width: 190px;
			height: 54px;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.intro{
			flex: 1;
		}
		.app-img {
			position: absolute;
			bottom: 0;
			img {
				width: 100%;
				height: 100%;
			}
		}
	}
	.mb-54{
		margin-bottom: 54px;
	}
	@media (max-width: 768px) {
		.application{
			padding: 0 !important;
			.header {
				padding: 32px 24px 24px !important;
			}
		}
		.fd-cl{
			display: block !important;
		}
		.header{
			padding-top: 0 !important;
		}
		.logo{
			display: flex;
			justify-content: center;
			max-height: 54px;
			img{
				max-width: 194px;
				height: 100%;
			}
		}
		.intro{
			padding-top: 16px;
		}
	}
</style>